var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { ProductComplianceLabelTypeEnum, ProductComplianceTechnicalHeadingTypeEnum } from '@inter-ikea-kompis/enums';
import { Text } from '@inter-ikea-kompis/component-text';
import { informationCircle, registerIcon } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import { InlineMessage as SkapaInlineMessage } from '@ingka/inline-message-webc/passive.js';
import LawLabelUtility from '../../utilities/LawLabelUtility.js';
import LawLabelCardStyle from './LawLabelCardStyle.js';
const LABEL_FILE_TYPE = 'svg';
/**
 * Law label images and disclaimer text.
 */
export default class LawLabelCard extends KompisElement {
    /**
     * @returns Template.
     */
    render() {
        return html `
			<style>
				${LawLabelCardStyle.getStyle({
            theme: this.theme
        })}
			</style>
			<div class="container">${this.getCard()}</div>
		`;
    }
    connectedCallback() {
        registerIcon(informationCircle);
        this.customElements.define('kompis-text', Text);
        this.customElements.define('skapa-inline-message', SkapaInlineMessage);
        this.customElements.define('skapa-icon', SkapaIcon);
        super.connectedCallback();
    }
    /**
     * Returns labels and disclaimer text if more than one label is found.
     */
    getCard() {
        const labels = this.getLabels();
        return html `
			${labels.length > 1 ? this.getDisclaimerText() : null}
			<div class="labels">${labels}</div>
		`;
    }
    /**
     * Returns disclaimer text.
     */
    getDisclaimerText() {
        const text = this.product.content?.complianceTechnical?.find((label) => label.headingType === ProductComplianceTechnicalHeadingTypeEnum.disclaimer)?.text;
        if (!text) {
            return null;
        }
        return html `
			<skapa-inline-message subtle class="message">
				<skapa-icon
					slot="message-icon"
					role="img"
					icon="information-circle"
					aria-hidden="false"
					aria-label="${this.translations.inlineMessageInformativeAriaLabel}"
				></skapa-icon>
				<span slot="body"> ${text} </span>
			</skapa-inline-message>
		`;
    }
    /**
     * Returns Array of label images.
     */
    getLabels() {
        return this.getLabelUrls().map((url) => html `<img src="${url}" alt="${this.getImageAlt(url)}" />`);
    }
    /**
     * Returns url to the label SVGs.
     */
    getLabelUrls() {
        if (this.product.content?.complianceLabel?.length) {
            return this.product.content.complianceLabel
                .filter((label) => label.labelType === ProductComplianceLabelTypeEnum.lawLabel &&
                label.fileType === LABEL_FILE_TYPE)
                .map((label) => label.url);
        }
        return [];
    }
    /**
     * Returns corresponding alt text for the law label image.
     */
    getImageAlt(url) {
        const labelText = LawLabelUtility.getLawLabelLinkText(this.product);
        const labelName = url.split('/').pop().split('.')[0];
        return `${labelText} ${labelName}`;
    }
}
__decorate([
    property({ type: Object, required: true })
], LawLabelCard.prototype, "product", void 0);
__decorate([
    property({ type: Object, required: true })
], LawLabelCard.prototype, "translations", void 0);
__decorate([
    property({ type: Object, required: true })
], LawLabelCard.prototype, "theme", void 0);
//# sourceMappingURL=LawLabelCard.js.map